import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OfflineInterceptor } from 'src/app/shared/offline/offline.interceptor';
import { AuthInterceptor } from './auth-interceptor';

export const httpInterceptorProvider = [
  // ANTES do AuthInterceptor: rota offline nao chama `next`, entao o JWT do Wazir nunca vai ao Barid.
  { provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
